import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=5b73a56c"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports